var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"medium"},[_c('moto-medium-size',{staticClass:"my-5"}),_c('short-description-medium-size'),_c('how-does-it-work-medium-size'),_c('partners-medium-size')],1)}
var staticRenderFns = []

export { render, staticRenderFns }